const CheckIcon = () => {
    return (
        <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='40' height='40' rx='20' fill='#98E9AC' />
            <path
                d='M30.5896 14.7563L17.2562 28.0896C17.1788 28.1671 17.0869 28.2285 16.9858 28.2705C16.8846 28.3124 16.7762 28.334 16.6666 28.334C16.5571 28.334 16.4487 28.3124 16.3475 28.2705C16.2464 28.2285 16.1545 28.1671 16.0771 28.0896L10.2437 22.2563C10.0874 22.0999 9.99951 21.8878 9.99951 21.6667C9.99951 21.4455 10.0874 21.2335 10.2437 21.0771C10.4001 20.9207 10.6122 20.8329 10.8333 20.8329C11.0544 20.8329 11.2665 20.9207 11.4229 21.0771L16.6666 26.3219L29.4104 13.5771C29.5668 13.4207 29.7788 13.3329 30 13.3329C30.2211 13.3329 30.4332 13.4207 30.5896 13.5771C30.7459 13.7335 30.8338 13.9455 30.8338 14.1667C30.8338 14.3878 30.7459 14.5999 30.5896 14.7563Z'
                fill='#090B2A'
            />
        </svg>
    );
};

export default CheckIcon;
